<template>
    <zen-message-modal :isOpen="isOpen" title="Resend welcome email?">
        Clicking the resend button below will send the user their welcome email
        and allow them to confirm their email address.
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Cancel
            </zen-button>
            <zen-button
                variant="primary"
                size="medium"
                :processing="processing"
                @click="$emit('confirm')"
            >
                Resend
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'ResendWelcomeEmailModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
